import cx from "classnames";
import React from "react";
import type { PolymorphicPropsWithoutRef } from "react-polymorphic-types";

import styles from "./styles.module.css";

export const CtaDefaultElement = "button";

export enum CtaTheme {
  DARK = "dark",
  LIGHT = "light",
  OUTLINE = "outline",
  OUTLINE_SECONDARY = "outline-secondary",
  OUTLINE_SQUARE = "outline-square",
  UNDERLINE = "underline",
}

export enum CtaSize {
  REGULAR = "regular",
  SMALL = "small",
  X_SMALL = "x-small",
}

interface CtaOwnProps {
  isLoading?: boolean;
  size?: CtaSize;
  theme?: CtaTheme;
}

export type CtaProps<T extends React.ElementType = typeof CtaDefaultElement> =
  PolymorphicPropsWithoutRef<CtaOwnProps, T>;

export function Cta<T extends React.ElementType = typeof CtaDefaultElement>({
  as,
  theme = CtaTheme.DARK,
  size = CtaSize.REGULAR,
  isLoading,
  className,
  children,
  ...restProps
}: CtaProps<T>) {
  const Element: React.ElementType = as || CtaDefaultElement;

  const containerClasses = cx(
    className,
    styles.button,
    styles[theme],
    styles[size]
  );

  return (
    <Element
      {...restProps}
      className={containerClasses}
      disabled={restProps["disabled"] || isLoading}
    >
      <span className={styles.inner}>{children}</span>
    </Element>
  );
}
